webpackJsonp([162898551421021],{

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/not-found.93b7c3e7.png";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _module = __webpack_require__(458);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _notFound = __webpack_require__(829);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: _module2.default.wrapper },
	    _react2.default.createElement(
	      'h1',
	      { className: _module2.default.heading },
	      'The page you requested can\'t be found'
	    ),
	    _react2.default.createElement('img', { className: _module2.default.image, src: _notFound2.default }),
	    _react2.default.createElement(
	      'a',
	      { className: (0, _classnames2.default)('button is-primary', _module2.default.button), href: '/' },
	      'Go to Support Overview'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-pages----404-module---wrapper---P1LDU","image":"src-pages----404-module---image---3jRBY","heading":"src-pages----404-module---heading---1S2uI","button":"src-pages----404-module---button---16zuU","spinAround":"src-pages----404-module---spinAround---2e0HD"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-56f3a8c3fea423113de9.js